/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { RecaptchaVerifier, signInWithPhoneNumber } from "@firebase/auth";
import {
    Avatar,
    Card,
    Group,
    Input,
    List,
    ListItem,
    LoadingOverlay,
    Paper,
    Stepper,
    Title,
    Tooltip
} from '@mantine/core';
import { useScrollLock, useViewportSize } from "@mantine/hooks";
import React, {useEffect, useMemo, useRef, useState} from 'react';
import { DeviceMobile, MessageDots, UserCheck } from "tabler-icons-react";
import Logo from "../assets/logo-no-background.png";
import PhoneWidget from "../components/Authenticate/PhoneWidget";
import SmsWidget from "../components/Authenticate/SmsWidget";
import Button from "../components/Inputs/Button";
import {auth, firestore} from "../firebase";
import useBoardHook from "../utils/useBoardHook";
import BoardCard from "../components/BoardCard";
import useGetAdminDataBoard from "../utils/useGetAdminDataBoard";
import {collection, doc} from "firebase/firestore";
import {useFirestoreDocumentData} from "@react-query-firebase/firestore";
import GeoPattern from "geopattern";
import InputGallery from "../components/Inputs/InputGallery";
import {AiOutlinePlus} from "react-icons/ai";
import InputMask from 'react-input-mask';
import useFirebaseFunction from "../utils/useFirebaseFunction";
import AppLoadingAnimation from "../components/AppLoadingAnimation";
import {useSearchParams} from "react-router-dom";


const Login = () => {
    const captchaRef = useRef(null);
    const { height:heighViewSize } = useViewportSize();
    const [searchParams, setSearchParams] = useSearchParams();

    const [hasSentSMS,setHasSentSMS] = useState(false);
    const [loadingSMS,setLoadingSMS] = useState(false);
    const [loadingPhone,setLoadingPhone] = useState(false);
    const [board, setBoard] = useState();
    const [open_board, isBoardOpening] = useFirebaseFunction("open_board", "europe-west1");

    const [loginLoading, setLoginLoading] = useState(null);

    const [active, setActive] = useState(0);

    const [phone,setPhone] = useState('');
    const [sms,setSMS] = useState('');
    const [errors,setErrors] = useState('');

    const subdomainRaw = window.location.pathname.replace("/", "");
    const subdomain = subdomainRaw === "dashboard" ? null : subdomainRaw;
    const isRsvp = !!searchParams.get("rsvp");

    //const board = useBoardHook(subdomain, false, subdomain === "");
    const refAdmin = doc (collection(firestore, 'public_users'), board?.data?.admin || "a");
    const {data: getAdmin} = useFirestoreDocumentData(['public_users', board?.data?.admin], refAdmin, {}, {enabled: !!board?.data?.admin});

    const adminAvatar = getAdmin?.avatar;
    const adminFirstName = getAdmin?.firstName;
    const adminLastName = getAdmin?.lastName;
    const adminInitials = adminFirstName?.split('')[0]+adminLastName?.split('')[0];

    const submitPhone = () => {
        window.recaptchaVerifier = new RecaptchaVerifier(captchaRef?.current, {
            size: 'invisible'
        }, auth);

        setErrors('');
        setLoadingPhone(true);

        if(!phone.length) {
            setLoadingPhone(false);
            return setErrors('Numărul de telefon este invalid')
        }

        let clearPhone = phone.replace('-','').replace('-','').replace(/\s/g, '');

        if(clearPhone.includes('_')){
            setLoadingPhone(false);
            return setErrors('Numărul de telefon este invalid');
        }

        signInWithPhoneNumber(auth,phone,window.recaptchaVerifier)
            .then((confirmationResult) => {
                window.confirmationResult = confirmationResult;

                setErrors('');
                setLoadingPhone(false);
                return setHasSentSMS(true);
            })
            .catch((error) => {
                if(Array(error)[0].code === "auth/too-many-requests"){
                    setLoadingPhone(false);
                    return setErrors("Te rugăm să încerci peste 5 minute");
                }
                if (error) {
                    setLoadingPhone(false);
                    return setErrors("Te rugăm să încerci mai tarziu")
                }
            });
    }


    const submitSMS = async () => {
        setLoadingPhone(true);

        setActive(2);

        window.confirmationResult.confirm(sms)
            .then(() => {
                setLoadingPhone(false);
                setErrors('');
            })
            .catch(err => {
                setActive(1);
                setLoadingSMS(false);
                return setErrors('Cod invalid');
            })
    }

    useEffect(() => {
        if (subdomain && subdomain !== "dashboard") {
            open_board({subdomain})
                .then((result) => {
                    setBoard(result);
                })
        }
    }, [subdomain]);

    useEffect(() => {
        if (hasSentSMS) {
            setActive(1);
        } else {
            setActive(0);
        }
    }, [hasSentSMS])

    useEffect(()=>{
        console.log("phone",phone);
    },[phone]);

    useEffect(() => {
        if (loginLoading === null) {
            if (!isBoardOpening) {
                return;
            }
        }
        setLoginLoading(isBoardOpening)
    }, [isBoardOpening, loginLoading])

    const backgroundStyling = useMemo(() => {
        let initial = {
            backgroundImage:'url(/background-login.png)',
            backgroundPosition:'center center',
            backgroundSize:'cover'
        };

        if (board?.data) {
            const source = board?.data?.image ? `https://d2uqrxzbny1jco.cloudfront.net/fit-in/1000x1000/${board?.data?.image}` : `${GeoPattern.generate(subdomain).toDataUri()}`;
            initial = {
                backgroundImage: `url('${source}')`,
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundColor: 'rgba(0,0,0,0.6)',
                backgroundBlendMode: 'soft-light',
                alignItems: "center",
            }

        }
        return initial;
    }, [board?.data])


    if (subdomain && subdomain !== "dashboard" &&  (loginLoading === null || loginLoading === true )) {
        return (<LoadingOverlay visible={true} loader={<AppLoadingAnimation/>}/>);
    }
    return (
        <div 
            style={{...backgroundStyling,height: heighViewSize+'px'}}
            className="relative w-full flex items-center pt-24 flex-col"
        >
                <div className={` ${!subdomain ? 'max-w-[200px]' : 'w-full'}  mb-10`}>
                    {subdomain  ?
                         board?.data?.title && (<div className="flex flex-col w-full px-4 justify-center items-center">
                            <InputGallery
                                board={board}
                                admin={false}
                                value={"test2"}
                                className="headingTitle"
                            />
                            <InputGallery
                                board={board}
                                admin={false}
                                value={"test"}
                                className="headingDate"
                            />
                        </div>)
                    : 
                    <img className="h-full " alt="Picboard" src={Logo} style={{height: 60}}/>}
                </div>


                <div className="max-w-[355px] sm:max-w-[470px] w-full">
                <Card shadow="sm" p="sm" radius="md" withBorder>
                    <Stepper active={active} mb={25} mt={12}>
                        <Stepper.Step icon={<DeviceMobile/>}>
                            <Title order={4}>Care este numărul tău de telefon?</Title>
                        </Stepper.Step>
                        <Stepper.Step icon={<MessageDots/>}>
                            <Title order={4}>Codul SMS</Title>
                        </Stepper.Step>
                    </Stepper>



                    <Paper style={{overflow: 'hidden',background:'transparent'}}>
                        {!hasSentSMS
                            ?
                            <Input
                                styles={{wrapper:{border:'1px solid #cacaca',marginLeft:'auto',marginRight:'auto',width:'300px',borderRadius:'5px'},input:{height:'42px',textAlign:'center'}}}
                                size="lg"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                variant="unstyled"
                                component={InputMask} 
                                mask="+40 999-999-999" 
                                placeholder="+40 ___-___-___" 
                            />
                            :
                            <SmsWidget errors={errors} sms={sms} setSMS={setSMS} />
                        }
                        <div style={{overflow: 'hidden'}} ref={captchaRef}></div>
                    </Paper>
                    <Group position={'center'} mt={25}>
                        {!hasSentSMS && <Button  loading={loadingPhone} onClick={() => submitPhone()} label="Continuă" />}
                        {hasSentSMS && (
                            <React.Fragment>
                                <Button color={'gray'}  onClick={() => setHasSentSMS(false)} label="Înapoi" />
                                <Button loading={loadingSMS} onClick={() => submitSMS()} label="Continuă" />
                            </React.Fragment>
                        )}
                    </Group>
                </Card>

                {subdomain && 
                    <a href={!!getAdmin?.data?.website.length && getAdmin?.data?.website} target="_blank" rel="noreferrer" className="cursor-pointer absolute flex flex-col justify-center items-center bottom-4 left-1/2 transform -translate-x-1/2">
                    {adminAvatar ?
                        <Avatar className="mb-2" radius="xl" style={{width:'50px',height:'50px'}} src={`https://d2uqrxzbny1jco.cloudfront.net/fit-in/200x200/${adminAvatar}`} alt="AvatarAdmin" />
                        :
                        (!adminAvatar && adminFirstName && adminLastName
                                ?
                                <Avatar className="mb-2 uppercase" color="blue" radius="xl" style={{width:'50px',height:'50px'}} src={null} alt="AvatarUser">{adminInitials}</Avatar>
                                :
                                <Avatar className="mb-2 uppercase" color="blue" radius="xl" style={{width:'50px',height:'50px'}} src={null} alt="AvatarUser" />
                    )}
                    <h1 className="headingPhotograph">{adminFirstName} {adminLastName}</h1>
                    </a>}



            </div>
        </div>
    )
}

export default Login